<template>
<div id="app">
  <div class="banner"><img src="./img/banner.png" alt=""></div>
  <div class="ability_box">
    <h5><span>—</span>我们的服务能力<span>—</span></h5>
    <div class="bg_outer bg1">
      <img class="img" src="./img/1-left.png">
      <div class="side_info">
        <img src="./img/1-1-icon.png" alt="">
        <h3>{{instiCount}}</h3>
        <p>大救星平台服务商总数</p>
        <img src="./img/2-2-icon.png" alt="">
        <h3>233<span> / 个国家</span></h3>
        <h3>60万+<span>/服务网点</span></h3>
        <!-- <p>大救星平台服务资源覆盖网络</p> -->
      </div>
      <h6>全球救援服务资源网络</h6>
    </div>
    <div class="bg_outer bg2">
      <img class="img" src="./img/2-right.png">
      <h6>全球双语星使覆盖网络</h6>
      <div class="side_info">
        <img src="./img/2-1-icon.png" alt="">
        <h3>{{providerCount}}</h3>
        <p>大救星平台星使总数</p>
        <img src="./img/2-2-icon.png" alt="">
        <h3>138<span> / 个国家</span></h3>
        <h3>820<span> / 个城市</span></h3>
        <!-- <p>大救星平台服务资源分布国家和城市</p> -->
      </div>
    </div>
    <h5><span>—</span>我们的服务案例<span>—</span></h5>
    <ul>
      <li v-for="(item,index) in caseList" :key="index" @click="godetail(item.id)">
        <img :src="item.pic?item.pic:require('./img/default.jpg')" alt="">
        <p>
          {{item.title}}
          </p>
          <div class="tit_show">
            {{item.title}}
          </div>
      </li>
    </ul>
    <div style="height:128px"></div>
  </div>
</div>
</template>

<script>
import util from '@/util/util.js'
import Axios from 'axios'
export default {
  data () {
    return {
        caseList: '',
        api:util.config.api,
        instiCount:0,
        providerCount:0,
    };
  },
  created(){
    this.getData()
  },
  methods: {
    getData(){
      Axios({
        params:{
          category:'2',
          start:'0',
          type:'11',
          count:'4'
        },
        methods:'post',
        baseURL: this.api,
        url: '/1.0/news/news-list'
      }).then(res=>{
        console.log(res.data.obj,'案例');
        this.caseList = res.data.obj;
      }).catch(error=>{
        console.log(error)
    })
    Axios({
          params: {
          },
          methods: 'post',
          baseURL: this.api,
          url: '/rescue/screen/total'
        }).then(res => {
          this.instiCount = res.data.obj.instiCount
          this.providerCount = res.data.obj.providerCount
          // console.log(res,'服务商');
          // console.log(res.data.providerCount,'星使');
        }).catch(error => {
          console.log(error)
        })
    },
    godetail(id){
       this.$root.bus.$emit('only',5);
      this.$router.push({
        path:'aboutus',
        query: {
          activeName: 'case',
          id:id
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  #app{
    background: #fff;
  }
  .banner{
    width: 100%;
    /*height: 26vw;*/
    img{
      width: 100%
    }
  }
  @keyframes fadenum{ /*设置内容由显示变为隐藏*/

    0%{opacity: 0;}

    100%{opacity: 1;}

}
  @mixin cssdefault{
    box-shadow: 0 0 4px 0 hsla(0,0%,60%,.5);
    -ms-transition: all .5s ease-in;
    -moz-transition: all .5s ease-in;
    -webkit-transition: all .5s ease-in;
    transition: all .5s ease-in;
  }
  @mixin csshover{
    -webkit-box-shadow: 0 0.78125vw 1.5625vw rgba(0,0,0,.1);
    box-shadow: 0 0.78125vw 1.5625vw rgba(0,0,0,.1);
    -webkit-transform: translate3d(0,-5px,0);
    transform: translate3d(0,-5px,0);
  }
  @mixin titH5{
    font-size: 1.666vw;
    color: #333;
    position: relative;
    text-align: center;
    padding: 2.8645833vw 0;
  }
  @mixin pseudo{
    content: "";
    position: absolute;
    width: 2.08333vw;
    height: 2px;
    top: 50%;
    background-color: #333;
  }
  .ability_box{
    padding: 0 17vw;
    h5{
      color: rgba(51,51,51,1);
      font-size: 1.6vw;
      margin: 2.5vw 0 2.6vw;
      text-align: center;
      clear: both;
      span{
        font-weight: normal;
        margin: 0 1.5vw;
        color: #000;
      }
    }
    .bg_outer{
      width: 100%;
      /*height: 30.1vw;*/
      margin-bottom: 1.25vw;
      background-size: contain;
      position: relative;
      box-sizing:border-box;
      -moz-box-sizing:border-box; /* Firefox */  
      -webkit-box-sizing:border-box; /* Safari */
      .img{
        width: 100%;
      }
      .side_info{
        padding: 0 4.427vw 3vw;
        img{
          width: 2.5vw;
          margin-top: 4vw;
        }
        h3{
          font-size:1.8vw;
          font-family:Arial Black;
          color: #fff;
          margin: 0.5vw 0; 
          span{
            font-size:1vw;
            color: #fff;
            font-weight: normal;
            padding: 0;
          }
        }
        p{
          color: #fff;
        }
      }
      h6{
        font-size: 1vw;
        font-weight: normal;
        color: #00ABFA;
        &::before{
          content: '';
          display: inline-block;
          width: 0.52083vw;
          height: 0.52083vw;
          border-radius: 50%;
          background: #00ABFA;
          margin-right: 8px;
        }
      }
      // *{
      //   padding: 0 4.427vw;
      // }
      
    }
    .bg1{
      clear: both;
      /*background: url('./img/1-left.png') no-repeat center center;*/
      .side_info{
        position: absolute;
        left: 0;
        top: 0;
        width: 28.5vw;
        /*background: url('./img/1-1.png') no-repeat center center;*/
      }
      h6{
        position: absolute;
        right: 0;
        top: 5vw;
        margin-right: 2.4vw;
      }
    }
    .bg2{
      /*background: url('./img/2-right.png') no-repeat center center;*/
      .side_info{
        position: absolute;
        right: 2vw;
        top: 0;
        width: 20vw;
        padding: 0;
      }
      h6{
        position: absolute;
        left: 0;
        top: 5vw;
        margin-left: 2.4vw;
      }
      
    }
    ul{
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      li{
       width: 15.104166vw;
        /* height: 15.104166vw;*/
        margin-right: 0.625vw;
        position: relative;
        cursor: pointer;
        @include cssdefault;
        img{
          width: 100%;
          height: 11.458vw;
        }
        p{
          height: 3.6458333vw;
          line-height: 3.6458333vw;
          padding: 0 1.25vw;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          &::before{
            content: '';
            width: 0.8854166vw;
            height: 0.8854166vw;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            background: url(./img/3-1-icon.png) no-repeat center center;
          }
        }
        .tit_show{
          display: none;
        }
      }
      li:hover{
        @include csshover;
        .tit_show{
           animation:fadenum 1s ease;
          position: absolute;
          width: 100%;
          height: 100%;
         /* width: 15.104166vw;
          height: 15.104166vw;*/
          background:linear-gradient(180deg,rgba(105,173,254,1),rgba(77,195,249,1));
          // border-radius:6px;
          font-size: 1.0412vw;
          color: #fff;
          text-align: center;
          top: 0;
          left: 0;
          vertical-align: middle;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 1.6666vw;
          box-sizing: border-box;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/ability/ability.vue